import {Inject, Injectable} from '@angular/core';
import {MessageRequest} from '../model/message-request.model';
import { HttpClient, HttpParams } from '@angular/common/http';
import { CplItemType } from '../model/enum/cpl-item-type.enum';
import { BaseApi, BASE_URL } from '@edl-development/edl-common';
@Injectable()
export class ComplyMessageApi extends BaseApi {
    constructor(
        @Inject(BASE_URL) private baseUri: string,
        private http: HttpClient
    ) {
        super();
    }

    getMessages(offset?: number, limit?: number, orderBy?: string, ascending?: boolean, searchBy?: string, start?:string, end?:string) {
        const params = new HttpParams()
            .append('offset', String(offset))
            .append('limit', String(limit))
            .append('orderBy', this.convertParam(orderBy))
            .append('ascending', String(ascending))
            .append('searchBy', this.convertParam(searchBy))
            .append('start', this.convertParam(start))
            .append('end', this.convertParam(end));

        return this.http.get(this.baseUri + '/cpl/messages', {
            params,
        });
    }

    getHistoryMessages({ historyId, typeId, offset, limit, } : { historyId: string, typeId: CplItemType, offset?: number, limit?: number }) {
            const params = new HttpParams()
                .append('offset', String(offset))
                .append('limit', String(limit));
        
            return this.http.get(this.baseUri + `/cpl/messages/history/${historyId}/${typeId}`, {
                params,
            });
    }

    getMessage(messageRecipientId: string) {
        return this.http.get(this.baseUri + `/cpl/message/${messageRecipientId}`);
    }

    getMessageTransmissionDetails(messageRecipientId: string) {
        return this.http.get(this.baseUri + `/cpl/message/transmission/${messageRecipientId}`);
    }

    sendMessage(message: MessageRequest) {
        return this.http.post(this.baseUri + '/cpl/message', message, { responseType: 'text' });
    }

    nudge(message: MessageRequest) {
        return this.http.post(this.baseUri + '/cpl/message/nudge', message, { responseType: 'text' });
    }
}